// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609150704/js/" + chunkId + "." + {"44":"ac7dfc3f","225":"e2477269","481":"568b3e32","486":"278ab57d","770":"9fd1af42"}[chunkId] + ".0.4936639336616413.chunk.js";
};